import React from "react";

export const Dealers = () => {
  return <div>dealers</div>;
};
